import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4514bddd"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "trenner" }, null, -1))
const _hoisted_2 = {
  class: "flex justify-between items-center h-7",
  "data-cy": "pdf-coverpage-header"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs" }, "Kategorie der Einschränkung:", -1))
const _hoisted_4 = { class: "" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PdfChip = _resolveComponent("PdfChip")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_PdfChip, {
          color: "green",
          "mangel-amount-mode": "",
          value: "keine",
          "pdf-mode": ""
        })
      ]),
      _createElementVNode("div", null, [
        _createVNode(_component_PdfChip, {
          color: "blue",
          "mangel-amount-mode": "",
          value: "geringfügige",
          "pdf-mode": ""
        })
      ]),
      _createElementVNode("div", null, [
        _createVNode(_component_PdfChip, {
          color: "yellow",
          "mangel-amount-mode": "",
          value: "massive",
          "pdf-mode": ""
        })
      ]),
      _createElementVNode("div", null, [
        _createVNode(_component_PdfChip, {
          color: "red",
          "mangel-amount-mode": "",
          value: "nicht realisierbar",
          "pdf-mode": ""
        })
      ])
    ])
  ]))
}